import React, { createContext, useContext } from 'react';

type DependencyContextProps<T> = {
    dependencies: T;
    children: React.ReactNode;
};

interface DependencyContextType<T> {
    Provider: React.FC<DependencyContextProps<T>>;
    useDependencies: () => T;
}

const createDependencyContext = <T,>(): DependencyContextType<T> => {
    const DependencyContext = createContext<T | null>(null);

    const DependencyProvider: React.FC<DependencyContextProps<T>> = ({ dependencies, children }) => (
        <DependencyContext.Provider value={dependencies}>{children}</DependencyContext.Provider>
    );

    const useDependencies = (): T => {
        const context = useContext(DependencyContext);
        if (context === null) {
            throw new Error('useDependencies must be used within a DependencyProvider');
        }
        return context;
    };

    return { Provider: DependencyProvider, useDependencies };
};

export default createDependencyContext;
